import { __assign, __read, __rest, __spreadArray } from "tslib";
import React, { useEffect, useState } from 'react';
import { Table } from '@tencent/tea-component/lib/table';
import { StatusTip } from '@tencent/tea-component/lib';
import classnames from 'classnames';
import i18n from '../i18n';
var t = i18n.t;
var LoadingTip = StatusTip.LoadingTip, ErrorTip = StatusTip.ErrorTip, EmptyTip = StatusTip.EmptyTip;
var stylize = Table.addons.stylize;
function Pagination(props) {
    var onPagingChange = props.onPagingChange, _a = props.current, current = _a === void 0 ? 1 : _a, recordCount = props.recordCount, _b = props.pageSize, pageSize = _b === void 0 ? 10 : _b, _c = props.miniPagination, miniPagination = _c === void 0 ? false : _c, classNames = props.classNames;
    var pages = Math.ceil(recordCount / pageSize);
    var showPagination = recordCount > pageSize;
    var showPagesCount = 5;
    var _d = __read(useState(current > Math.ceil(recordCount / pageSize) || current < 1 ? 1 : current), 2), page = _d[0], setPage = _d[1];
    // TODO:current一直是非受控的，正常怎么用的？？
    useEffect(function () {
        if (current) {
            setPage(current);
        }
    }, [current]);
    var pageList = [];
    var min;
    var max;
    var handlePageChange = function (e, index) {
        var currentPage = page;
        e.preventDefault();
        switch (index) {
            case 'pre':
                currentPage = page > 1 ? page - 1 : 1;
                setPage(currentPage);
                break;
            case 'next':
                currentPage = page < pages ? page + 1 : page;
                setPage(currentPage);
                break;
            default:
                currentPage = index;
                setPage(index);
        }
        if (onPagingChange && currentPage !== page) {
            onPagingChange({ pageIndex: currentPage, pageSize: pageSize });
        }
    };
    // 计算页面边界值
    if (pages <= showPagesCount) {
        min = 1;
        max = pages;
    }
    else {
        min = page - 2;
        max = page + 2;
        if (min <= 0) {
            min = 1;
            max = 5;
        }
        if (max > pages) {
            min = pages - 4;
            max = pages;
        }
    }
    var _loop_1 = function (i) {
        pageList.push(React.createElement("a", { href: "", key: i, className: classnames('buy-pagination-item', { 'buy-pagination-item-active': i === page }), onClick: function (e) { return handlePageChange(e, i); } }, i));
    };
    // 生成展示的页面
    for (var i = min; i <= max; i++) {
        _loop_1(i);
    }
    // 加入省略号
    if (min - 1 > 1) {
        pageList.unshift(React.createElement("span", { key: "pre-more", className: "buy-pagination-dot" }, "..."));
    }
    if (pages - max > 1) {
        pageList.push(React.createElement("span", { key: "net-more", className: "buy-pagination-dot" }, "..."));
    }
    // 加入首页和尾页
    if (min !== 1) {
        pageList.unshift(React.createElement("a", { href: "", key: "first-pager", className: classnames('buy-pagination-item'), onClick: function (e) { return handlePageChange(e, 1); } }, "1"));
    }
    if (max !== pages) {
        pageList.push(React.createElement("a", { href: "", key: "last-pager", className: classnames('buy-pagination-item'), onClick: function (e) { return handlePageChange(e, pages); } }, pages));
    }
    if (!showPagination) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, t('共 {{ recordCount }} 项', {
            recordCount: recordCount,
        })),
        React.createElement("div", { className: "buy-pagination-wrap" },
            React.createElement("div", { className: classnames('buy-pagination', { 'buy-pagination-mini': miniPagination }, classNames) },
                React.createElement("a", { href: "", className: "buy-pagination-item buy-pagination-item-prev " + (page <= 1 ? 'buy-pagination-item-disabled' : ''), onClick: function (e) { return handlePageChange(e, 'pre'); } },
                    React.createElement("div", { className: "buy-icon buy-icon-preview" })),
                pageList.map(function (item) { return item; }),
                React.createElement("a", { href: "", className: "buy-pagination-item buy-pagination-item-next " + (page >= pages ? 'buy-pagination-item-disabled' : ''), onClick: function (e) { return handlePageChange(e, 'next'); } },
                    React.createElement("div", { className: "buy-icon buy-icon-next" }))))));
}
export function BuyTable(_a) {
    var _b, _c, _d;
    var _e;
    var pagination = _a.pagination, type = _a.type, autotip = _a.autotip, note = _a.note, props = __rest(_a, ["pagination", "type", "autotip", "note"]);
    var _f = autotip || {}, isLoading = _f.isLoading, loadingText = _f.loadingText, isError = _f.isError, isEmpty = _f.isEmpty, errorText = _f.errorText, retryText = _f.retryText, onRetry = _f.onRetry, hideIcon = _f.hideIcon;
    var records = props.records, columns = props.columns;
    if (isError) {
        records = [
            (_b = {
                    id: '1'
                },
                _b[columns[0].key] = (React.createElement("div", { className: "buy-text-table-loading-data-state" },
                    React.createElement(ErrorTip, { errorText: errorText, retryText: retryText, hideIcon: hideIcon, onRetry: onRetry }))),
                _b),
        ];
    }
    else if (isEmpty) {
        records = [
            (_c = {
                    id: '1'
                },
                _c[columns[0].key] = (React.createElement("div", { className: "buy-text-table-no-data-state" },
                    React.createElement(EmptyTip, null))),
                _c),
        ];
    }
    else if (isLoading) {
        records = [
            (_d = {
                    id: '1'
                },
                _d[columns[0].key] = (React.createElement("div", { className: "buy-text-table-loading-data-state" },
                    React.createElement(LoadingTip, { loadingText: loadingText }))),
                _d),
        ];
    }
    // 异常状态优先展示异常状态，屏蔽数据的同时也要屏蔽columns中的render，不然render会基于空数据展示与状态共存
    var isNotNeedRender = isError || isEmpty || isLoading;
    if (isNotNeedRender) {
        columns = columns.map(function (_a) {
            var render = _a.render, others = __rest(_a, ["render"]);
            return others;
        });
    }
    var addons = __spreadArray([
        stylize({
            bodyClassName: classnames({
                'buy-text-table-loading-data': isError || isLoading,
                'buy-text-table-no-data': isEmpty,
            }),
        })
    ], __read(((_e = props.addons) !== null && _e !== void 0 ? _e : [])));
    var showPagination = pagination && (pagination === null || pagination === void 0 ? void 0 : pagination.recordCount) > ((pagination === null || pagination === void 0 ? void 0 : pagination.pageSize) || 10);
    return (React.createElement("div", { className: "buy-" + type + "-table" },
        React.createElement(Table, __assign({}, props, { addons: addons, records: records, columns: columns })),
        (note || (pagination && showPagination)) && (React.createElement("div", { className: classnames("buy-" + type + "-table-note", { 'buy-text-table-pagination': pagination }) },
            note && React.createElement("p", { className: "buy-" + type + "-table-note-content" }, note),
            pagination && Pagination(pagination)))));
}
BuyTable.addons = Table.addons;
//# sourceMappingURL=BuyTable.js.map